/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {pendTransaction} from '../api'

export const useMutationPendTransaction = createReactQueryMutationHook('pendTransaction', pendTransaction)
